import ScheduleIcon from "@mui/icons-material/Schedule";
import Assignment from "@mui/icons-material/AssignmentOutlined";
import Library from "@mui/icons-material/LocalLibraryOutlined";
import Announcement from "@mui/icons-material/AnnouncementOutlined";
import TermExams from "@mui/icons-material/QuizOutlined";
import LearnIcon from "@mui/icons-material/LibraryBooksOutlined";
import MiscellaneousIcon from "@mui/icons-material/MiscellaneousServicesOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import ContentPasteOutlinedIcon from "@mui/icons-material/ContentPasteOutlined";
import { createTheme } from "@mui/material/styles";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import WarmUpLogo from "assets/Warm-up icon.svg";
import { featureConfigConstants } from "app-component/helpers";
import GamepadIcon from "@mui/icons-material/Gamepad";

import LayersIcon from "@mui/icons-material/Layers"; // represents layers/levels


// import HierarchiesMapIcon from 'assets/Hierarchies.svg'
import AccountTree from "@mui/icons-material/AccountTree";
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import LiveTvIcon from '@mui/icons-material/LiveTv';

import { csvLeadsUser, plateformConfigueUser,academicTagsUser, liveClassesUser, NCMS_ROLES, LIVE_CLASSES_ROLES } from "utils/role-restriction/helper";
import SchoolIcon from '@mui/icons-material/School';
import DevicesOutlinedIcon from '@mui/icons-material/DevicesOutlined';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';

export const dummyFeatureConfig = {
  disable_assignments: true,
};

export const drawerWidth = 285;

export const features = [
  {
    isDisable: false,
    name: "Assignments",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_ASSIGNMENTS,
    icon: Assignment,
    children: [
      { name: "Create", type: "item", link: "/assignments/create" },
      { name: "List", type: "item", link: "/assignments/list" },
      {
        name: "List Deliveries",
        type: "item",
        link: "/assignments/delivery-list",
      },
    ],
  },
  {
    isDisable: false,
    name: "Term Exams",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_TERM_EXAMS,
    link: "/term-exams",
    icon: PendingActionsOutlinedIcon,
    children: [
      { name: "Create", type: "item", link: "/term-exams/create" },
      { name: "List", type: "item", link: "/term-exams/list" },
      {
        name: "List Deliveries",
        type: "item",
        link: "/term-exams/delivery-list",
      },
      // {
      //   name: "QP Create PDF",
      //   type: "item",
      //   link: "/term-exams/generate-paper",
      // },
      {
        name: "Saved Papers",
        type: "item",
        link: "/term-exams/saved-papers",
      },
    ],
  },

  {
    isDisable: false,
    name: "Build Test",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_BUILD_TEST,
    link: "/build-test",
    icon: ContentPasteOutlinedIcon,
    children: [
      {
        name: "Template",
        type: "item",
        link: "/build-test/template-list",
      },
      {
        name: "Question Group",
        type: "item",
        link: "/build-test/question-group-list",
      },
      { name: "Schedule Tests", type: "item", link: "/build-test/tests" },
      { name: "Delivery", type: "item", link: "/build-test/delivery" },
      { name: "Create With Excel", type: "item", link: "/build-test/create-with-excel" },
      { name: "NEAP - Delivery", type: "item", link: "/build-test/neap" },
    ],
  },

  {
    name: "Warm-Up Delivery",
    type: "item",
    featureConfigKey: featureConfigConstants.DISABLE_WARM_UP_DELIVERY,
    link: "/warm-up-delivery",
    icon: WarmUpLogo,
    imageType: "svg",
    children: [],
  },

  {
    name: "Learn",
    type: "collapse",
    link: "/learn",
    featureConfigKey: featureConfigConstants.DISABLE_LEARN,
    icon: LearnIcon,
    children: [
      {
        name: "Create",
        type: "item",
        link: "/learn/create",
      },
      {
        name: "List",
        type: "item",
        link: "/learn/list",
      },
      { name: "Lock Topics", type: "item", link: "/learn/locktopics" },
      { name: "Disable Topics", type: "item", link: "/learn/disabletopics" },
    ],
  },

  {
    name: "Library",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_LIBRARY,
    icon: Library,
    children: [{ name: "List", type: "item", link: "/library" }],
  },
  {
    name: "Monthly Schedule",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_MONTHLY_SCHEDULE,
    icon: ScheduleIcon,
    children: [
      { name: "Create", type: "item", link: "/monthly-schedule/create" },
      {
        name: "List",
        type: "item",
        link: "/monthly-schedule/list",
      },
    ],
  },

  {
    name: "Announcements",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_ANNOUNCEMENTS,
    link: "/announcements",
    // featureConfigKey: featureConfigConstants.DISABLE_ANNOUNCEMENTS,
    icon: Announcement,
    children: [
      { name: "Create", type: "item", link: "/announcements/create" },
      { name: "List", type: "item", link: "/announcements/list" },
    ],
  },

  {
    name: "Activities",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_ACTIVITIES,
    link: "/activities",
    icon: SportsEsportsOutlinedIcon,
    children: [
      { name: "Create", type: "item", link: "/activities/create" },
      { name: "List", type: "item", link: "/activities/list" },
    ],
  },

  {
    name: "Hierarchies",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_HIERARCHIES,
    link: "/hierarchies",
    icon: AccountTree,
    children: [
      {
        name: "View Hierarchies",
        type: "item",
        link: "/hierarchies/view-hierarchies",
      },
      {
        name: "Map Hierarchy to Question",
        type: "item",
        link: "/hierarchies/map-hierarchy-to-question",
      },
    ],
  },

  {
    name: "Miscellaneous",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_MISCELLANEOUS,
    link: "/miscellaneous",
    icon: MiscellaneousIcon,
    children: [
      {
        name: "Instructions",
        type: "item",
        link: "/miscellaneous/instructions",
      },
      { name: "Misc Data", type: "item", link: "/miscellaneous/misc-data" },
      {
        name: "View Question",
        type: "item",
        link: "/miscellaneous/view-question",
      },
    ],
  },
  {
    name: "Games",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_GAMES,
    link: "/games",
    icon: GamepadIcon,
    children: [
      {
        name: "Vendor",
        type: "item",
        link: "/games/vendors",
      },
      {
        name: "Games",
        type: "item",
        link: "/games/games",
      },
      {
        name: "Tags",
        type: "item",
        link: "/games/tags",
      },
      {
        name: "Tag Items",
        type: "item",
        link: "/games/tag/items",
      },
      {
        name: "Game Tags",
        type: "item",
        link: "/games/gamestags",
      },
      {
        name: "Users",
        type: "item",
        link: "/games/users",
      },
      {
        name: "UserGames",
        type: "item",
        link: "/games/usergames",
      },
    ],
  },
  {
    name: "Platform Configue",
    type: "collapse",
    link: "/configue",
    featureConfigKey: featureConfigConstants.DISABLE_CONFIGUE,
    icon: DevicesOutlinedIcon,
    children: [
      {
        name: "Force Update",
        type: "item",
        link: "/configue/force_update",
        user:[...plateformConfigueUser?.FORCE_UPDATE_READ,...plateformConfigueUser?.FORCE_UPDATE_READ_WRITE]
      },
      {
        name: "Feature Config",
        type: "item",
        link: "/configue/feature_configue",
        user:[...plateformConfigueUser?.FEATURE_CONFIGUE_READ,...plateformConfigueUser?.FEATURE_CONFIGUE_READ_WRITE]
      },
      {
        name: "Student Course Lookup",
        type: "item",
        link: "/configue/student_course_lookup",
        user:[...plateformConfigueUser?.STD_COURSE_LU_READ,...plateformConfigueUser?.STD_COURSE_LU_READ_WRITE]
      },
      {
        name: "Student Program Lookup",
        type: "item",
        link: "/configue/student_program_lookup",
        user:[...plateformConfigueUser?.STD_PROGRAM_LU_READ,...plateformConfigueUser?.STD_PROGRAM_LU_READ_WRITE]
      },
      {
        name: "Create Course",
        type: "item",
        link: "/configue/create_course",
        user:[...plateformConfigueUser?.CREATE_COURSE_READ_WRITE]
      },
      {
        name: "Create Program",
        type: "item",
        link: "/configue/create_program",
        user:[...plateformConfigueUser?.CREATE_PROGRAM_READ_WRITE]
      },
      {
        name: "Language Preference",
        type: "item",
        link: "/configue/language_preferance",
        user:[...plateformConfigueUser?.LANGUAGE_PREFERANCE_READ,...plateformConfigueUser?.LANGUAGE_PREFERANCE_READ_WRITE]
      },

    ],
  },
  {
    name: "Test Status",
    type: "item",
    featureConfigKey: featureConfigConstants.DISABLE_TEST_STATUS,
    link: "/teststatus",
    icon: ShowChartOutlinedIcon,
    //imageType: "svg",
    children: [],
  },
  {
    name: "Academic Tags",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_ENTITIES,
    link: "/entities",
    icon: SchoolIcon,
    children: [
      {
        name: "Academic Year",
        type: "item",
        link: "/entities/year",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
      {
        name: "Batch",
        type: "item",
        link: "/entities/batch",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
      {
        name: "Branch",
        type: "item",
        link: "/entities/branch",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
      {
        name: "Class",
        type: "item",
        link: "/entities/class",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
      {
        name: "State",
        type: "item",
        link: "/entities/state",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
      {
        name: "District",
        type: "item",
        link: "/entities/district",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
      {
        name: "Sbd Batch",
        type: "item",
        link: "/entities/actual_sbd_batch",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
      {
        name: "Sbd Program",
        type: "item",
        link: "/entities/actual_sbd_program",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
      {
        name: "Class Batch Map",
        type: "item",
        link: "/entities/class_batch_map",
        user: [
          ...academicTagsUser.ACADEMIC_TAGS_READ,
        ...academicTagsUser.ACADEMIC_TAGS_READ_WRITE,
      ],
      },
    ]
  },
  {
    name: "Leads Generation",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_LEADS_GENERATION,
    link: "/leadsgenerations",
    icon: CloudSyncIcon,
    children: [
      {
        name: "Upload Leads",
        type: "item",
        link: "/leadsgenerations/upload",
        user:[...csvLeadsUser.CSV_LEADS_READ,...csvLeadsUser.CSV_LEADS_READ_WRITE
        ]
      }
    ],
  },
  {
    name: "Live Classes",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_LIVE_CLASSES,
    link: "/live-classes",
    icon: LiveTvIcon,
    children: [
      {
        name: "Products",
        type: "item",
        link: "/live-classes/products",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
      },
      {
        name: "Platforms",
        type: "item",
        link: "/live-classes/platforms",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
        
      },
      {
        name: "Projects",
        type: "item",
        link: "/live-classes/projects",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
       
      },
      {
        name: "Vendors",
        type: "item",
        link: "/live-classes/vendors",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
      },
      {
        name: "Vendor Accounts",
        type: "item",
        link: "/live-classes/vendor-accounts",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
      },
      {
        name: "Vendor Users",
        type: "item",
        link: "/live-classes/vendor-users",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
        
      },
      {
        name: "Vendor Project Users",
        type: "item",
        link: "/live-classes/vendor-project-users",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
        
      },
      {
        name: "Employee Departments",
        type: "item",
        link: "/live-classes/employee-departments",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
      },
      {
        name: "Employee Designations",
        type: "item",
        link: "/live-classes/employee-designations",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
        
      },
      {
        name: "Teachers",
        type: "item",
        link: "/live-classes/teachers",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER]
      },
      {
        name: "NL3 Liveclass Packages",
        type: "item",
        link: "/live-classes/nlearn3-liveclass-packages",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]
      },
      {
        name: "NL3 Package Schedules",
        type: "item",
        link: "/live-classes/nlearn3-package-schedules",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]
      },
      {
        name: "NL3 LC Pkg Group Subscriber",
        type: "item",
        link: "/live-classes/nlearn3-liveclass-group-package-subscribers",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]
      },
      {
        name: "NL3 Liveclass Masters",
        type: "item",
        link: "/live-classes/nlearn3-liveclass-masters",
        user: [LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]
      },
    ]
  },
{
    name: "Exam Schedule",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_EXAM_SCHEDULE,
    link: "/exam_schedule",
    icon: ScheduleSendIcon,
    children: [
      {
        name: "Schedule",
        type: "item",
        link: "/exam_schedule/list",
      }]
    },
      {
    name: "Global Content Hierarchy",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_ENTITIES,
    link: "/global-content-hierarchy",
    icon: LayersIcon, 
    children: [
      {
        name: "Courses",
        type: "item",
        link: "/global-content-hierarchy/courses",
      },
      {
        name: "Subjects",
        type: "item",
        link: "/global-content-hierarchy/subjects",
      },
      {
        name: "Chapters",
        type: "item",
        link: "/global-content-hierarchy/chapter"
      },
      {
        name: "Topics",
        type: "item",
        link: "/global-content-hierarchy/topic"
      },
      {
        name: "CSC-Mapping",
        type: "item",
        link: "/global-content-hierarchy/course_class_sub_chap_map"
      },
      {
        name: "CSCT-Mapping",
        type: "item",
        link: "/global-content-hierarchy/course_class_sub_chap_top_map"
      },
    ]
  },
    { 
    name: "Operations",
    type: "collapse",
    featureConfigKey: featureConfigConstants.DISABLE_LEADS_GENERATION,
    link: "/operations",
    icon: CloudSyncIcon,
    children: [
      {
        name: "Branch IP Config",
        type: "item",
        link: "/operations/question_ip",
      }
    ],
  },
];

export const getEnableFeatures = (featureConfig) => {
  if (!featureConfig) return [];

  return features.filter((feature) => !featureConfig[feature.featureConfigKey]);
};

export const drawerTheme = createTheme({
  components: {
    MuiListItemButton: {
      defaultProps: {
        disableTouchRipple: true,
      },
    },
  },
  palette: {
    mode: "dark",
    primary: { main: "rgb(102, 157, 246)" },
    background: { paper: "rgb(15, 23, 42)" },
  },
});
